
// Functions.js
import { useAlert } from './AlertContext';

export function useAddToFav() {
    const { showAlert } = useAlert();

    const AddToFav = (video, setIsFav) => {
        const existing = JSON.parse(localStorage.getItem("LK_Favorites")) || [];
        const index = existing.findIndex(v => v.Thumbnail === video.Thumbnail);
      
        let updated;
        if (index !== -1) {
            updated = existing.filter((_, i) => i !== index);
            showAlert("Removed from Favorites!");
            console.log("fav clicked 1 !")
            setIsFav(false);
        } else {
            updated = [...existing, video];
            showAlert("Added to Favorites!");
            console.log("fav clicked 2 !") 
            setIsFav(true);
        }
    
        localStorage.setItem("LK_Favorites", JSON.stringify(updated));
    };
    


    return AddToFav;
}



export const checkIfFav = (videoId, setIsFav) => {
    const favs = JSON.parse(localStorage.getItem("LK_Favorites")) || [];
    const exists = favs.some(v => v.ID === videoId); // or `v.id === videoId` if you have IDs
    setIsFav(exists);
};


